import { type SearchRequest } from '@searchkit/api';

type ExtendedSearchRequest = SearchRequest & {
  facet?: string;
  type?: 'facet';
};

export function createQueryFactory() {
  return (searchRequest: ExtendedSearchRequest): SearchRequest => {
    return {
      ...searchRequest,
      body: {
        size: 0,
        query: {
          bool: {
            must: [...(searchRequest.body?.query ? [searchRequest.body.query] : [])],
          },
        },
        aggs: {
          players: {
            terms: {
              field: 'sportsData.participant.participantId',
              size: 1000,
            },
            aggs: {
              name_value: {
                top_hits: {
                  _source: {
                    includes: ['sportsData.participant'],
                  },
                  size: 1,
                },
              },
            },
          },
          event_info: {
            top_hits: {
              _source: {
                includes: [
                  'teamData',
                  'subeventStartTime',
                  'eventDisplayName',
                  'subeventName',
                  'subeventId',
                  'categoryGroupName',
                ],
              },
              size: 1,
            },
          },
        },
      },
    };
  };
}
